import { Button } from "@/components/ui/button";
import {
  ArrowLeft, Save, Eye, Undo2, Lock, Unlock,
  ArrowUpToLine, ArrowDownToLine, AlignCenterHorizontal,
  RotateCcw, LayoutGrid, Check, Copy, Trash2
} from "lucide-react";

export function EditorToolbar({
  templateName, selected, selectedEl, history,
  saving, savedFeedback, showPreview,
  onBack, onSave, onUndo, onTogglePreview,
  onToggleLock, onCenterH, onBringToFront, onSendToBack,
  onDuplicate, onDelete, onOpenPresets, onOpenReset,
}) {
  return (
    <div className="h-12 bg-white border-b border-slate-200 flex items-center px-3 gap-2 shrink-0" data-testid="editor-toolbar">
      <Button variant="ghost" size="sm" onClick={onBack} className="h-8 px-2" data-testid="editor-back-btn">
        <ArrowLeft className="w-4 h-4 mr-1" /> <span className="text-xs">Volver</span>
      </Button>
      <div className="h-5 w-px bg-slate-200" />
      <span className="font-bold text-xs text-slate-700 truncate max-w-[180px]">{templateName}</span>
      <div className="flex-1" />

      {selected && (
        <div className="flex items-center gap-1 mr-2 border-r border-slate-200 pr-2">
          <button onClick={onToggleLock} className="p-1 rounded hover:bg-slate-100" title={selectedEl?.locked ? "Desbloquear" : "Bloquear"} data-testid="toggle-lock-btn">
            {selectedEl?.locked ? <Lock className="w-3.5 h-3.5 text-amber-500" /> : <Unlock className="w-3.5 h-3.5 text-slate-400" />}
          </button>
          <button onClick={onCenterH} className="p-1 rounded hover:bg-slate-100" title="Centrar horizontal" data-testid="center-h-btn">
            <AlignCenterHorizontal className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={onBringToFront} className="p-1 rounded hover:bg-slate-100" title="Traer al frente" data-testid="bring-front-btn">
            <ArrowUpToLine className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={onSendToBack} className="p-1 rounded hover:bg-slate-100" title="Enviar al fondo" data-testid="send-back-btn">
            <ArrowDownToLine className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <div className="w-px h-4 bg-slate-200 mx-0.5" />
          <button onClick={onDuplicate} className="p-1 rounded hover:bg-slate-100" title="Duplicar (Ctrl+D)" data-testid="toolbar-dup-btn">
            <Copy className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={onDelete} className="p-1 rounded hover:bg-red-50" title="Eliminar (Supr)" data-testid="toolbar-del-btn">
            <Trash2 className="w-3.5 h-3.5 text-red-500" />
          </button>
        </div>
      )}

      <Button variant="ghost" size="sm" onClick={onUndo} disabled={history.length === 0} className="h-8 px-2" data-testid="editor-undo-btn" title="Deshacer (Ctrl+Z)">
        <Undo2 className="w-3.5 h-3.5" />
      </Button>
      <Button variant="outline" size="sm" onClick={onOpenPresets} className="h-8 px-2 text-xs" data-testid="open-presets-btn">
        <LayoutGrid className="w-3.5 h-3.5 mr-1" /> Plantillas
      </Button>
      <Button variant="outline" size="sm" onClick={onOpenReset} className="h-8 px-2 text-xs" data-testid="reset-btn">
        <RotateCcw className="w-3.5 h-3.5 mr-1" /> Restablecer
      </Button>
      <Button variant="outline" size="sm" onClick={onTogglePreview} className="h-8 px-2 text-xs" data-testid="editor-preview-btn">
        <Eye className="w-3.5 h-3.5 mr-1" /> {showPreview ? "Editar" : "Preview"}
      </Button>
      <Button size="sm" onClick={onSave} disabled={saving} className={`h-8 px-3 text-xs transition-colors ${savedFeedback ? "bg-emerald-600 hover:bg-emerald-700" : "bg-slate-900 hover:bg-slate-800"}`} data-testid="editor-save-btn">
        {savedFeedback ? <><Check className="w-3.5 h-3.5 mr-1" /> Guardado</> : saving ? "Guardando..." : <><Save className="w-3.5 h-3.5 mr-1" /> Guardar</>}
      </Button>
    </div>
  );
}
